import { AccountBalanceWallet } from '@assets/svgs/AccountBalanceWallet'
import { CurrencyDollarSimple } from '@assets/svgs/CurrencyDollarSimple'
import { InfoIcon } from '@assets/svgs/InfoIcon'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { TrendingUp } from '@assets/svgs/TrendingUp'
import { currencyMask } from '@utils/masks/currencyMask'
import { PreviewCard } from '../PreviewCard'

import type { BudgetPreviewsProps } from './types'

import { TooltipExplanation } from '@components/shared/TooltipExplanation/inde'

const INVOICING_WEEK_COLORS = ['#C3E3E1', '#A1CFCE', '#7EBBBC', '#5BA7AA', '#3A9397']
const BUDGET_BORDER = '#7B8794'

export const budgetPreviews = ({ data }: BudgetPreviewsProps) => {
  if (!data) return []

  const week = data?.currentPreviewNumber ?? 3
  const previewBorderColor = INVOICING_WEEK_COLORS[week - 1] ?? INVOICING_WEEK_COLORS[2]

  return [
    <PreviewCard
      isBudget
      borderColor={BUDGET_BORDER}
      label="Budget"
      value={currencyMask((data?.budgetAmount || 0).toFixed(2))}
      icon={<AccountBalanceWallet />}
      bottomText="Orçamento Aprovado"
    />,
    <PreviewCard
      isBudget
      borderColor={previewBorderColor}
      label={!data?.currentPreviewNumber ? 'Prévia' : `Prévia ${data?.currentPreviewNumber}ª semana`}
      value={currencyMask((data?.previewBillingAmount || 0).toFixed(2))}
      icon={<CurrencyDollarSimple />}
      bottomText="Previsão Atual"
      infoIcon={
        <TooltipExplanation data={[{ label: 'Prévia (R$): ', text: ' Total Faturamento Líquido' }]}>
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      label="Desvio"
      borderColor={INVOICING_WEEK_COLORS[INVOICING_WEEK_COLORS.length - 1]}
      value={currencyMask((data?.deviationValue || 0).toFixed(2))}
      percentageValue={`${(data?.deviationPercentage || 0).toFixed(2)}%`.replace('.', ',')}
      icon={Number(data?.deviationValue) <= 0 ? <TrendingDown /> : <TrendingUp />}
      bottomText={Number(data?.deviationValue) <= 0 ? 'Abaixo do Budget' : 'Acima do Budget'}
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'Desvio (R$): ', text: 'Prévia (R$) - Budget' },
            { label: 'Desvio (%): ', text: 'Desvio (R$) ÷ Budget Faturamento * 100' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />
  ]
}
